// Password rules (3 Nov 2026): NIST SP 800-63B-4. Must match Supabase Auth
// settings (staging and production) - Authentication, Email provider:
//   Minimum password length = 15
//   Password requirements   = none (no required characters)
//   Prevent use of leaked passwords = on
// Change both together. Every screen's text and every app-side length check
// reads from here - no screen hard-codes a number.
export const PASSWORD_MIN_LENGTH = 15

// Password rules (3 Nov 2026): false = no required character mix (NIST).
// The mix-required wording is kept in passwordHint() in case this is ever
// switched back on - flip it here AND in Supabase together.
export const PASSWORD_REQUIRES_MIX = false
